var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowProcessRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 337,
    height: 140,
    viewBox: "0 0 337 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.93934 13.0607C0.353553 12.4749 0.353553 11.5251 0.93934 10.9393L10.4853 1.3934C11.0711 0.807612 12.0208 0.807612 12.6066 1.3934C13.1924 1.97918 13.1924 2.92893 12.6066 3.51472L4.12132 12L12.6066 20.4853C13.1924 21.0711 13.1924 22.0208 12.6066 22.6066C12.0208 23.1924 11.0711 23.1924 10.4853 22.6066L0.93934 13.0607ZM242 136.5H305V139.5H242V136.5ZM333.5 108V42H336.5V108H333.5ZM305 13.5H2V10.5H305V13.5ZM333.5 42C333.5 26.2599 320.74 13.5 305 13.5V10.5C322.397 10.5 336.5 24.603 336.5 42H333.5ZM305 136.5C320.74 136.5 333.5 123.74 333.5 108H336.5C336.5 125.397 322.397 139.5 305 139.5V136.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowProcessRight);
export default __webpack_public_path__ + "static/media/arrow-process-right.a71ab8998944cec24c880c4abec3d9ff.svg";
export { ForwardRef as ReactComponent };